import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'moment/locale/ru';
import 'antd/dist/antd.dark.css';
import './styles/index.scss';
import './declarations';
import './configure';

import { App } from './app';
import { configureHighchartsLabels } from './pages/dashboard-page/utils/data-labels-placement';
import './i18n';

import './polyfills';

configureHighchartsLabels();

const container = document.getElementById('root');

if (!container) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(container);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
